import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`If you have updated tracking, you can use group-based feature flags as normal in `}<a parentName="p" {...{
        "href": "https://posthog.com/docs/integrate/client/js"
      }}>{`posthog-js`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`if (posthog.isFeatureEnabled('new-groups-feature')) {
    // do something
}
`}</code></pre>
    <p>{`To check flag status for a different group, first switch the active group via a `}<inlineCode parentName="p">{`posthog.group()`}</inlineCode>{` call.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      